<!-- 评分评价-->
<template>
  <div id="grade">
    <div class="grade-box">
      <div class="breadcrumb-box">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item @click.native="$router.back(-1)"
            >企业测评</el-breadcrumb-item
          >
          <el-breadcrumb-item>{{ info.brandName }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="grade-title">
        <div>
          <h3>{{ info.brandName }}</h3>
          <div class="grade-title-info" style="display: flex;">
            时间：
            <span>{{ info.workDates }}</span>
            <span class="kg-class"></span>
            等级：
            <span> {{ info.grade != 1 ? "合格" : "不合格" }}</span>
            <div style="margin-left: 20px;flex: 1">
              <el-button size="small" @click="showDialog">导出</el-button>
            </div>
          </div>
        </div>
        <div class="grade-title-num">
          {{ Number((100 - rankDetail.total).toFixed(2)) }}
          <span>分</span>
        </div>
        <img
          src="@/assets/image/tui2.png"
          class="out"
          v-if="info.isOut"
          @click="getTip(info)"
        />
      </div>
      <div class="grade-content">
        <div class="grade-header">
          <el-row type="flex">
            <el-col :span="3" class="centered-text" style="margin-right: 2.5rem">分类</el-col>
            <el-col :span="3" class="centered-text border-left" style="margin-right: -2.5rem">考核项目</el-col>
            <el-col :span="1" class="centered-text" style="border-left: 1px solid #ebebeb;margin-left: 2.625rem;padding-left: 2.5rem; white-space: nowrap;">扣分上限</el-col>
            <el-col :span="3" class="centered-text border-left" style="margin-left: 3.125rem;">考核内容</el-col>
            <el-col :span="9" class="centered-text border-left">考核评分标准</el-col>
            <el-col :span="1" class="centered-text border-left" style="width: 7.5rem;padding-right: 1.25rem; white-space: nowrap;">扣分</el-col>
            <el-col :span="1" class="centered-text border-left" style="width: 7.5rem;padding-right: 1.25rem; white-space: nowrap;">详情</el-col>
            <el-col :span="3" class="centered-text border-left">得分</el-col>
          </el-row>
        </div>
        <div class="grade-items" v-for="i in brandDetail" :key="i.examineId">
          <el-row class="grade-row" type="flex">
            <el-col :span="3" class="grade-items-brand" style="text-align: center">
              <div class="grade-item-border-left" style=" left: -0.0625rem;"></div>
              {{i.categoryName}}
              <div class="grade-item-border-right" style=" right: -0.0625rem;"></div>
            </el-col>
            <el-col :span="21">
              <el-row type="flex" v-for="(item, k) in i.children" :key="k">
                <el-col :span="3" style="text-align: center">
                  <div class="grade-item-border-left" style="left: 0;"></div>
                  <span v-html="formatCategoryName(item.categoryName2, 12)"></span>
                </el-col>
                  <el-col
                    :span="2"
                    style="color:#ff544d;margin-right: -0.625rem;text-align: center;padding-right: 1.5625rem">
                  <div class="grade-item-border-left" style="left: 13.5rem;"></div>
                  {{ item.categoryScoreLimit>0 ? item.categoryScoreLimit : '/'}}
                </el-col>
                <el-col :span="16">
                  <el-row type="flex" v-for="(p, k) in item.children" :key="k" style="left: -0.125rem;">
                    <el-col :span="5" class="grade-items-text" style="text-align:center;padding-right: 1.5625rem">
                      <div class="grade-item-border-left" style="left: 13.375rem;"></div>
                      <span v-html="formatCategoryName(p.ruleName, 10)"></span>
                    </el-col>
                    <el-col :span="13" class="grade-items-text" style="text-align: left;">
                      <div class="grade-item-border-left" style="left: 0;"></div>
                      <span v-html="formatCategoryName(p.description, 46)"></span>
                    </el-col>
                    <el-col
                      :span="2"
                      class="grade-items-text"
                      style="color: #ff544d;text-align: center;padding-left: 5.625rem">
                      <div class="grade-item-border-left" style=" right: 13.9375rem;"></div>
                      {{ p.score ? p.score : 0}}</el-col>
                    <div class="grade-item-border-left" style="right: 6.9375rem;"></div>
                    <el-col :span="1" class="grade-items-text" style="padding-left: 6.5625rem">
                      <el-button
                        type="text"
                        @click="onShowComponent(p)"
                        v-if="p.score"
                        >
                        查看</el-button
                      >
                      <span v-else style="padding-left: 0.625rem">-</span>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col
                  :span="2"
                  class="grade-items-text"
                  style="color: #ff544d;text-align: center;padding-left: 5.3125rem;">
                  <div class="grade-item-border-left" style="right: 13.25rem;"></div>
                  {{ getScore(item) }}
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <koufen
      :infoShow="infoShow"
      :rankDetail="info"
      :detailTotal="detailTotal"
      :selfAreaId="id"
      @closepop="closepop"
    ></koufen>
    <w-dialog
      ref="w-dialog"
      title="选择导出字段"
      width="35%"
      sureBtnText="导出"
      @handleClose="handleCloseExport"
      @handleCloseRight="handleCloseExport"
      @onSure="onSureExport">
      <template v-slot:content>
        <div class="dialog-content">
          <el-checkbox
            :indeterminate="isIndeterminate"
            v-model="checkAll"
            @change="handleCheckAllChange"
          >全选
          </el-checkbox>
          <div style="margin: 15px 0"></div>
          <el-checkbox-group
            v-model="checkedFields"
            @change="handleCheckedFieldsChange"
          >
            <el-checkbox
              style="margin-bottom: 10px"
              v-for="item in rateOptions"
              :label="item.key"
              :key="item.key">
              {{ item.label }}
            </el-checkbox>
          </el-checkbox-group>
        </div>
      </template>
    </w-dialog>
  </div>
</template>

<script>
import koufen from './components/koufen'
import Api from '@/api'
import { compare, downloadExcel, getFilterParams } from '@/utils/tools'
import WDialog from '@/components/Model/index.vue'
export default {
  name: 'grade',
  components: {
    koufen,
    WDialog
  },
  data() {
    return {
      id: '',
      info: {},
      infoShow: false,
      brandId: '',
      detailTotal: {},
      rankDetail: {},
      checkedFields: [],
      isIndeterminate: true,
      checkAll: false,
      // 导出字段
      rateOptions: [
        {
          key: 1,
          label: '分类'
        },
        {
          key: 2,
          label: '考核项目'
        },
        {
          key: 3,
          label: '考核内容'
        },
        {
          key: 4,
          label: '考核评分标准'
        },
        {
          key: 5,
          label: '考核时间'
        },
        {
          key: 6,
          label: '得分'
        },
        {
          key: 7,
          label: '考核单位'
        },
        {
          key: 8,
          label: '备注'
        }]
    }
  },
  computed: {
    brandDetail() {
      if (this.rankDetail.brandDetail) {
        let arr = [
          this.rankDetail.detail4,
          this.rankDetail.detail2,
          this.rankDetail.detail3,
          this.rankDetail.detail1,
          this.rankDetail.detail6,
          this.rankDetail.detail5,
          ...this.rankDetail.category
        ]
        arr = arr.map(p => {
          const value = this.rankDetail.brandDetail.find(val => val.examineId == p.examineId)// 重复
          p = value || p
          return p
        })
        let arr2 = []
        for (const i of arr) {
          const index = arr2.findIndex((val) => {
            return val.categoryName == i.categoryName
          })
          if (index === -1) {
            arr2.push({
              categoryName: i.categoryName,
              children: [i]
            })
          } else {
            arr2[index].children.push(i)
          }
        }
        if (arr2.length > 0) {
          arr2 = arr2.map((data) => {
            const arr3 = []
            for (const i of data.children) {
              const index = arr3.findIndex((val) => {
                // 区分人工考核和系统考核
                if ((val.examineId > 0 && i.examineId > 0) || (val.examineId < 0 && i.examineId < 0)) {
                  return val.categoryName2 === i.categoryName2
                }
              })
              if (index === -1) {
                arr3.push({
                  categoryName2: i.categoryName2,
                  categoryScoreLimit: i.categoryScoreLimit,
                  examineId: i.examineId,
                  children: [i]
                })
              } else {
                arr3[index].children.push(i)
              }
            }
            return {
              categoryName: data.categoryName,
              children: arr3
            }
          })
        }
        return arr2
      } else {
        return []
      }
    }
  },
  created() {
    this.id = this.$route.params.id
    this.info = JSON.parse(this.$route.query.data)
    const { brandId, workDate } = this.info
    this.info.workDates = this.dayjs(workDate + '').format(
      'YYYY年MM月考评细则'
    )
    Api.getRankDetail({ brandId, workDate, selfAreaId: this.id }).then(
      ({ data }) => {
        this.rankDetail = data
      }
    )
  },
  methods: {
    // 点击统计按钮，弹出组件
    onShowComponent(val) {
      this.detailTotal = val
      this.infoShow = true
    },
    // 组件返回关闭组件操作
    closepop() {
      this.infoShow = false
    },
    getTip(data) {
      Api.getBrandOut({
        selfAreaId: this.id,
        brandId: data.brandId,
        type: 'month',
        now: data.workDate
      }).then(({ data }) => {
        const reason = []
        if (data.length > 0) {
          data.forEach((val) => {
            val.infoBak = JSON.parse(val.infoBak)
            console.log(val.infoBak)
            if (val.infoBak.examineInfo) {
              val.infoBak.examineInfo = JSON.parse(val.infoBak.examineInfo)
              const name = val.infoBak.examineInfo.title
              if (!reason.includes(name)) {
                reason.push(name)
              }
            }
            if (val.source) {
              const name = { 100: '重点区域偏多调度', 150: '普通区域偏多调度', 200: '站外还车调度', 250: '非法车辆调度' }[val.source]
              if (!reason.includes(name)) {
                reason.push(name)
              }
            }
          })
        }
        this.$alert(
          `<p>违反了“<span style='color:#1F8FFB'>${reason.join(',')}</span>”考核内容设置，按照规则触发退市。</p>`,
          '退市说明',
          {
            dangerouslyUseHTMLString: true,
            showConfirmButton: false
          }
        )
      })
    },
    getScore(item) {
      let totalScore = 0
      if (item.children && item.children.length > 0) {
        for (const child of item.children) {
          totalScore = (totalScore * 100 + child.score * 100) / 100 // 累加children数组中所有元素的score值
        }
      }
      // 返回得分=categoryScoreLimit减去children数组中所有元素的score之和
      let score = 0
      if (item.categoryScoreLimit) {
        // 设置扣分上限时：得分为0或者负数时；均设置得分为0
        score = (item.categoryScoreLimit - totalScore) > 0 ? (item.categoryScoreLimit - totalScore) : 0
      } else {
        // 未设置扣分上限时：得分为0或者负数，不做限制
        score = (item.categoryScoreLimit - totalScore)
      }
      return parseFloat(score)
    },
    // 考核项目-10个字符换行，最多换一行
    formatCategoryName(content, num) {
      if (content.length > num) {
        const regex = new RegExp('(.{' + num + '})', 'g')
        return content.replace(regex, '$1<br>')
      }
      return content
    },
    showDialog() {
      this.$refs['w-dialog'].onShowDialog()
    },
    handleCloseExport() {
      this.checkedFields = []
      this.isIndeterminate = true
      this.checkAll = false
      this.$refs['w-dialog'].onCloseDialog()
    },
    onSureExport() {
      const vm = this
      vm.tableLoading = true
      if (vm.checkedFields.length < 4) {
        vm.$message.warning('请至少选择4项！')
        return
      }
      let data = {}
      data = {
        areaId: this.id,
        brandId: this.info.brandId,
        startTime: this.info.workDate,
        endTime: this.info.workDate,
        score: Number((100 - this.rankDetail.total).toFixed(2))
      }
      data.export =
        vm.checkedFields && vm.checkedFields.length
          ? vm.checkedFields.sort(compare).join(',') : ''
      data = getFilterParams(data)
      console.log(data, 'data')
      console.log(this.id)
      Api.evaluationRule(this.id, data).then((res) => {
        if (res.code === 200) {
          console.log(res)
          downloadExcel(res.data)
          vm.tableLoading = false
          vm.handleCloseExport()
        } else {
          vm.$message.warning(res.message)
        }
        vm.tableLoading = false
      })
    },
    handleCheckAllChange(val) {
      console.log(val)
      this.checkedFields = val ? this.rateOptions.map((it) => it.key) : []
      this.isIndeterminate = false
    },
    handleCheckedFieldsChange(value) {
      const checkedCount = value.length
      this.checkAll = checkedCount === this.rateOptions.length
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.rateOptions.length
    }
  }
}
</script>
<style scoped lang="less">
#grade {
  overflow: auto;
  .grade {
    &-title {
      font-size: 18px;
      line-height: 36px;
      text-align: left;
      background: #fff;
      margin-bottom: 16px;
      padding: 24px 32px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      position: relative;
      &-info {
        font-size: 14px;
        color: rgba(0, 0, 0, 0.25);
        span {
          color: rgba(0, 0, 0, 0.45);
        }
        .kg-class {
          margin-left: 55px;
        }
      }
      &-num {
        color: #44acff;
        font-size: 34px;
        line-height: 60px;
        span {
          font-size: 16px;
        }
      }
      .out {
        position: absolute;
        right: 0;
        bottom: 0;
        cursor: pointer;
      }
    }

    &-box {
      padding: 16px;
      .breadcrumb-box {
        /deep/ .el-breadcrumb {
          line-height: 36px;
        }
      }
    }
    &-header {
      background: #fafafc;
      line-height: 40px;
      .el-col {
        padding-left: 20px;
      }
    }
    &-content {
      padding-bottom: 30px;
    }
    &-items {
      background: #fff;
      color: rgba(0, 0, 0, 0.65);
      line-height: 18px;
      .el-row {
        border-bottom: 1px solid #ebebeb;
        align-items: center;
        padding-left: 20px;

        .el-row:last-child {
          border-bottom: 0;
        }
        .grade-items-text {
          padding: 18px 0;
        }
      }
    }
  }
}
/*评分评价细则表格加边框*/
.grade-item-border-left {
  border-left: 1px solid #ebebeb;
  height: 100%;
  position: absolute;
  top: 0;
}
.grade-item-border-right {
  border-right: 1px solid #ebebeb;
  height: 100%;
  position: absolute;
  top: 0;
}
.grade-item-text {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  text-align: center;
}

/*评分评价细则表格表头居中*/
.centered-text {
  display: flex;
  justify-content: center;
  align-items: center;
}
.border-left {
  border-left: 1px solid #ebebeb;
}
</style>
